import React, { useEffect, useState } from 'react';
import {
  Box,
  GDSStyleObject,
  Fieldset,
  ParagraphText,
  Radio,
  StackLayout,
  FormField,
  Select,
} from '@leagueplatform/genesis-core';
import COBQuestioner from '../../../../assets/json/COB_QUESTIONER.json';
import { isEmpty, isNotEmpty } from '../../../helpers/helpers';
import useCobStore from '../../../../store/cob-store';
import '../../forms.css';
import { COBLayout } from '../../../cob-layout/cob-layout';

export function Custody(props: any) {
  const [underCustody, setUnderCustody] = useState('');
  const { nextButtonClicked, OPISResponseInfo, errorHandling, nextDisabled } =
    props;
  const [hasCustody, setHasCustody] = useState(false);

  const dependantList = useCobStore((state: any) => state.demographics);

  const [form, setForm] = useState({
    custody: OPISResponseInfo?.custody ? OPISResponseInfo?.custody : '',
    parentWithPrimaryMedicalResponsibility:
      OPISResponseInfo?.parentWithPrimaryMedicalResponsibility
        ? OPISResponseInfo?.parentWithPrimaryMedicalResponsibility
        : '',
    dependentInformationCourtOrder:
      OPISResponseInfo?.dependentInformationCourtOrder
        ? OPISResponseInfo?.dependentInformationCourtOrder
        : '',
  });

  const [errors, setErrors] = useState({
    custody: false,
    parentWithPrimaryMedicalResponsibility: false,
    dependentInformationCourtOrder: false,
  });

  useEffect(() => {
    let checkStatus: boolean;
    if (form.custody === '') {
      nextDisabled(false);
    } else if (form.custody === 'N') {
      nextDisabled(false);
    } else {
      checkStatus =
        isNotEmpty(form.parentWithPrimaryMedicalResponsibility) &&
        isNotEmpty(form.dependentInformationCourtOrder);
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      if (checkStatus) {
        nextDisabled(false);
        setErrors({
          custody: false,
          parentWithPrimaryMedicalResponsibility: isEmpty(
            form.parentWithPrimaryMedicalResponsibility,
          ),
          dependentInformationCourtOrder: isEmpty(
            form.dependentInformationCourtOrder,
          ),
        });
      } else {
        nextDisabled(true);
      }
    }
  }, [
    nextDisabled,
    form.custody,
    form.parentWithPrimaryMedicalResponsibility,
    form.dependentInformationCourtOrder,
  ]);

  useEffect(() => {
    if (OPISResponseInfo.custody !== 'N' && OPISResponseInfo.custody !== '') {
      setHasCustody(true);
    } else {
      setHasCustody(false);
    }
  }, [setHasCustody, OPISResponseInfo.custody]);

  const checkFormValid = () => {
    if (hasCustody) {
      return isNotEmpty(form.custody);
      // &&
      // isNotEmpty(form.parentWithPrimaryMedicalResponsibility) &&
      // isNotEmpty(form.dependentInformationCourtOrder)
    }
    return isNotEmpty(form.custody);
  };

  const checkFormFieldValid = () => {
    if (hasCustody) {
      return isEmpty(form.custody);
      // &&
      // isEmpty(form.parentWithPrimaryMedicalResponsibility) &&
      // isEmpty(form.dependentInformationCourtOrder)
    }
    return isEmpty(form.custody);
  };

  const formField = checkFormFieldValid();

  const isValid = checkFormValid();

  const custodyNominee =
    COBQuestioner.COB.QUESTIONS.CONTROLS.CUSTODY.CUSTODYCONTROL;
  const custodyCourtNominee =
    COBQuestioner.COB.QUESTIONS.CONTROLS.CUSTODY.CUSTODYRELATION;
  const custodyByCourt = COBQuestioner.COB.QUESTIONS.CONTROLS.CUSTODY.BYCOURT;

  // eslint-disable-next-line consistent-return
  const possibleOptions = (relation: string) => {
    switch (relation) {
      case 'None':
        return 'N';
        break;
      case 'Mother':
        return 'M';
        break;
      case 'Father':
        return 'F';
        break;
      case 'Joint':
        return 'J';
        break;
      default:
        break;
    }
  };

  const custodyNomineeList = () => {
    const custodyList = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < custodyNominee.length; i++) {
      if (i === 0) {
        custodyList.push({
          key: '',
          value: '',
          label: COBQuestioner.COB.QUESTIONS.CONTROLS.CUSTODY.CONTROLSELECTONE,
        });
        custodyList.push({
          key: i.toString(),
          value: possibleOptions(custodyNominee[i]),
          label: custodyNominee[i],
        });
      } else {
        custodyList.push({
          key: i.toString(),
          value: possibleOptions(custodyNominee[i]),
          label: custodyNominee[i],
        });
      }
    }
    return custodyList;
  };

  const custodyCourt = () => {
    const courtList = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < custodyByCourt.length; i++) {
      const custodyReferance = custodyByCourt[i] === 'Yes' ? 'Y' : 'N';
      if (i === 0) {
        courtList.push({
          key: '',
          value: '',
          label: COBQuestioner.COB.QUESTIONS.CONTROLS.CUSTODY.CONTROLSELECTONE,
        });
        courtList.push({
          key: i.toString(),
          value: custodyReferance,
          label: custodyByCourt[i],
        });
      } else {
        courtList.push({
          key: i.toString(),
          value: custodyReferance,
          label: custodyByCourt[i],
        });
      }
    }
    return courtList;
  };

  const byCourtList: any = custodyCourt();
  const custodian: any = custodyNomineeList();

  const updateHandler = (event?: any) => {
    OPISResponseInfo.custody = event.target.value;

    form.custody = event.target.value;
    setUnderCustody(OPISResponseInfo.custody);
    if (event.target.value) {
      OPISResponseInfo.dependentInformationCourtOrder = '';
      OPISResponseInfo.parentWithPrimaryMedicalResponsibility = '';
      form.dependentInformationCourtOrder = '';
      form.parentWithPrimaryMedicalResponsibility = '';
      setErrors({
        custody: false,
        parentWithPrimaryMedicalResponsibility: false,
        dependentInformationCourtOrder: false,
      });
      errorHandling(true);
    } else {
      setErrors({
        custody: isEmpty(form.custody),
        parentWithPrimaryMedicalResponsibility: false,
        dependentInformationCourtOrder: false,
      });
      errorHandling(false);
    }
  };

  const updateCustodyHandler = (event: any) => {
    const { value, id } = event.target;
    setForm({
      custody: form.custody,
      parentWithPrimaryMedicalResponsibility:
        form.parentWithPrimaryMedicalResponsibility,
      dependentInformationCourtOrder: form.dependentInformationCourtOrder,
    });

    setErrors({
      ...errors,
      [id]: isEmpty(value),
    });
  };
  const updateParentWithPrimaryMedicalResponsibility = (event: any) => {
    form.parentWithPrimaryMedicalResponsibility = event.target.value;
    OPISResponseInfo.parentWithPrimaryMedicalResponsibility =
      event.target.value;
    updateCustodyHandler(event);
  };

  const updateDependentInformationCourtOrder = (event: any) => {
    form.dependentInformationCourtOrder = event.target.value;
    OPISResponseInfo.dependentInformationCourtOrder = event.target.value;
    updateCustodyHandler(event);
  };

  useEffect(() => {
    if (OPISResponseInfo?.custody) {
      setUnderCustody(OPISResponseInfo?.custody);
    }
    if (nextButtonClicked) {
      if (!isValid) {
        setErrors({
          custody: isEmpty(form.custody),
          parentWithPrimaryMedicalResponsibility: isEmpty(
            form.parentWithPrimaryMedicalResponsibility,
          ),
          dependentInformationCourtOrder: isEmpty(
            form.dependentInformationCourtOrder,
          ),
        });
      }
    }
    if (isValid) {
      errorHandling(true);
    } else {
      errorHandling(false);
    }
  }, [
    OPISResponseInfo?.custody,
    errorHandling,
    form.custody,
    form.dependentInformationCourtOrder,
    form.parentWithPrimaryMedicalResponsibility,
    isValid,
    nextButtonClicked,
    underCustody,
  ]);

  useEffect(() => {
    if (
      formField ||
      errors.custody ||
      errors.parentWithPrimaryMedicalResponsibility ||
      errors.dependentInformationCourtOrder
    ) {
      errorHandling(false);
    } else {
      errorHandling(true);
    }
  });
  return (
    <COBLayout
      title={
        OPISResponseInfo?.member?.firstName ===
          dependantList.demographics?.firstName &&
        OPISResponseInfo.member?.dateOfBirth ===
          dependantList?.demographics?.dateOfBirth
          ? COBQuestioner.COB.INFORMATION.YOUROTHERINSURANCE
          : `${`${OPISResponseInfo.member.firstName} ${OPISResponseInfo.member.lastName}${COBQuestioner.COB.INFORMATION.DEPENDENTOTHERINSURANCE}`}`
      }
      dataTestId="custody"
      questionTitle={COBQuestioner.COB.QUESTIONS.CONTROLS.CUSTODY.TITLE}
      disclaimer={
        COBQuestioner.COB.QUESTIONS.CONTROLS.EMPLOYEMENTSTATUS.SELECTONE
      }
      isDependant={false}
    >
      <Box
        css={
          {
            marginBottom: '15px',
          } as GDSStyleObject
        }
      >
        <Box
          css={
            {
              marginBottom: '15px',
            } as GDSStyleObject
          }
        >
          <Fieldset
            legend=""
            id="custodyStatus"
            css={
              {
                marginTop: '$half',
                borderRadius: '$medium',
              } as GDSStyleObject
            }
            inputStatus={errors.custody ? 'error' : undefined}
          >
            {custodyCourtNominee.map((item) => (
              <Radio
                id={`${`underCustody${item.id}`}`}
                name="custody"
                value={possibleOptions(item.relation)}
                label={item.relation}
                style={{ color: 'blue' }}
                layout="row"
                css={
                  {
                    width: '345px',
                    marginBottom: '15px',
                    '& label': {
                      boxShadow: '0px 2px 6px 0px #00000014',
                      border: '1px solid #d6d6d6',
                      borderRadius: '7px',
                      height: '64px',
                      cursor: 'pointer',
                      marginBottom: '$one',
                      '& span:first-child': {
                        paddingLeft: '8px',
                      },
                      '& span:last-child': {
                        '& input': {
                          marginRight: '8px',
                        },
                      },
                    },
                  } as GDSStyleObject
                }
                checked={
                  OPISResponseInfo?.custody === possibleOptions(item.relation)
                }
                onChange={(e) => {
                  updateHandler(e);
                }}
              />
            ))}
          </Fieldset>
        </Box>
        {hasCustody && (
          <StackLayout
            css={{
              display:
                underCustody !==
                possibleOptions(
                  COBQuestioner.COB.QUESTIONS.CONTROLS.CUSTODY
                    .CUSTODYCONTROL[0],
                )
                  ? 'block'
                  : 'none',
            }}
          >
            <Box
              css={
                {
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'left',
                  padding: '$quarter $none $none $none',
                } as GDSStyleObject
              }
            >
              <ParagraphText
                css={
                  {
                    marginTop: 'quarter',
                    marginBottom: '$oneAndHalf',
                    fontSize: '$headingTwo',
                    fontWeight: 600,
                    lineHeight: '$headingTwo',
                  } as GDSStyleObject
                }
              >
                {COBQuestioner.COB.QUESTIONS.CONTROLS.CUSTODY.CUSTODYINFO}
              </ParagraphText>
              <FormField
                id="parentWithPrimaryMedicalResponsibility"
                label={COBQuestioner.COB.QUESTIONS.CONTROLS.CUSTODY.COURTORDER}
                aria-label={
                  COBQuestioner.COB.QUESTIONS.CONTROLS.CUSTODY.COURTORDER
                }
                statusIconLabel="Error"
                inputStatus={
                  errors.parentWithPrimaryMedicalResponsibility
                    ? 'error'
                    : undefined
                }
                statusMessage={
                  errors.parentWithPrimaryMedicalResponsibility
                    ? COBQuestioner.COB.ERRORS.PRIMARYRESPONSIBILITY
                    : ''
                }
                css={{
                  lineHeight: '$subtitleOne',
                  paddingBottom: '8px',
                  '.GDS-input-wrapper': {
                    lineHeight: '$subtitleOne',
                    paddingBottom: '2px',
                  },
                }}
              >
                <Select
                  options={byCourtList}
                  id="hasCourtOrder"
                  aria-label="selected Dependent Info"
                  css={
                    {
                      marginTop: '$half',
                      marginBottom: '$quarter',
                      fontSize: '$headingTwo',
                      fontWeight: 600,
                      '@mobile': { padding: '$quarter', width: '345px' },
                      '@desktop': { width: '345px' },
                    } as GDSStyleObject
                  }
                  value={
                    OPISResponseInfo?.parentWithPrimaryMedicalResponsibility
                  }
                  onChange={updateParentWithPrimaryMedicalResponsibility}
                />
              </FormField>
              <FormField
                id="dependentInformationCourtOrder"
                label={
                  <StackLayout
                    orientation="horizontal"
                    css={{
                      marginBottom: '$quarter',
                      fontSize: '$label',
                      fontWeight: 500,
                      color: '$onSurfaceTextSubdued',
                    }}
                  >
                    <span>
                      {
                        COBQuestioner.COB.QUESTIONS.CONTROLS.CUSTODY
                          .PARENTMEDICAL
                      }
                    </span>
                  </StackLayout>
                }
                aria-label={
                  COBQuestioner.COB.QUESTIONS.CONTROLS.CUSTODY.PARENTMEDICAL
                }
                statusIconLabel="Error"
                inputStatus={
                  errors.dependentInformationCourtOrder ? 'error' : undefined
                }
                statusMessage={
                  errors.dependentInformationCourtOrder
                    ? COBQuestioner.COB.ERRORS.DEPENDANTINFORMATION
                    : ''
                }
                css={
                  {
                    lineHeight: '$subtitleOne',
                    paddingBottom: '2px',
                    '.GDS-input-wrapper': {
                      lineHeight: '$subtitleOne',
                      paddingBottom: '2px',
                    },
                  } as GDSStyleObject
                }
              >
                <Select
                  options={custodian}
                  id="custodynominee"
                  aria-label="selected Dependent Info"
                  css={
                    {
                      marginTop: '$quarter',
                      marginBottom: '$quarter',
                      fontSize: '$headingTwo',
                      fontWeight: 600,
                      '@mobile': { padding: '$quarter', width: '345px' },
                      '@desktop': { width: '345px' },
                    } as GDSStyleObject
                  }
                  value={OPISResponseInfo?.dependentInformationCourtOrder}
                  onChange={updateDependentInformationCourtOrder}
                />
              </FormField>
            </Box>
          </StackLayout>
        )}
      </Box>
    </COBLayout>
  );
}
